export const UNCATEGORIZED = 'Uncategorized';

/**
 * Turns an upper snake-case code into a display label, e.g.
 * "CASE_MANAGEMENT" -> "Case Management". Falls back to "Uncategorized" for
 * empty input. Mirrors the local copies in AgentFlowEditor.jsx / TaskFlowEditor.jsx,
 * which group activity templates by the same task_type values.
 */
export function toTitleCase(str?: string | null): string {
    if (!str) return UNCATEGORIZED;
    return str
        .toLowerCase()
        .split(/[_\s]+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export interface SplitTitleResult {
    primary: string;
    secondary?: string;
}

/**
 * Splits a trailing "(...)" off a title string, e.g.
 * "Senior Fraud Investigator (Prioritize Suspicious Activity Alerts)" ->
 * { primary: "Senior Fraud Investigator", secondary: "Prioritize Suspicious Activity Alerts" }.
 * Returns the original string as `primary` (no `secondary`) when there is no
 * trailing parenthetical, or when parentheses appear mid-string instead.
 */
export function splitTrailingParenthetical(title: string): SplitTitleResult {
    const match = title.trim().match(/^(.*\S)\s*\(([^()]+)\)\s*$/);
    if (!match) {
        return { primary: title };
    }
    const [, primary, secondary] = match;
    return { primary, secondary };
}
